import { ITransponserFunctions, IUnitsConverterFunctions } from "@tedivo/tedivo-pure-helpers";

/** Print-oriented palette of the vessel particulars sheet (drawn on a white page) */
export interface IVesselParticularsColors {
  textColor: string;
  containerFill: string;
  containerStroke: string;
  hullStroke: string;
  hatchStroke: string;
  maxHeightStroke: string;
  zeroTcgStroke: string;
  tableStroke: string;
  accentColor: string;
  /** Tier/row numbers, like the Bay views' grid numbers (--sl-color-neutral-500) */
  gridNumberColor: string;
  /** Bottom base values, like the Bay views (--sl-color-primary-400) */
  bottomBaseColor: string;
  /** Port TCG values, like the Bay views (--sl-color-red-600) */
  tcgPortColor: string;
  /** Starboard TCG values, like the Bay views (--sl-color-green-600) */
  tcgStbdColor: string;
  /** Hatch-cover lid border, like the Bay views (--sl-color-green-400) */
  lidBorderColor: string;
  /** Hatch-cover lid fill, like the Bay views (--sl-color-green-100) */
  lidBackgroundColor: string;
  /** Hatch-cover lid label */
  lidTextColor: string;
}

export const VESSEL_PARTICULARS_PRINT_COLORS: IVesselParticularsColors = {
  textColor: "#1a1a1a",
  containerFill: "#ffffff",
  containerStroke: "#444444",
  hullStroke: "#1a1a1a",
  hatchStroke: "#666666",
  maxHeightStroke: "#b34700",
  zeroTcgStroke: "#999999",
  tableStroke: "#555555",
  accentColor: "#00417f",
  // Same hues the editor's Bay views resolve from the light Shoelace theme
  gridNumberColor: "#71717a",
  bottomBaseColor: "#38bdf8",
  tcgPortColor: "#dc2626",
  tcgStbdColor: "#16a34a",
  lidBorderColor: "#4ade80",
  lidBackgroundColor: "#dcfce7",
  lidTextColor: "#1a1a1a",
};

export interface IVesselParticularsUnits {
  lengthUnits: IUnitsConverterFunctions<unknown>;
  tcgTransposer: ITransponserFunctions<unknown>;
  vcgTransposer: ITransponserFunctions<unknown>;
  lcgTransposer: ITransponserFunctions<unknown>;
}
